import React from 'react';
import Gallery from '../function-components/Gallery/Gallery'

function GalleryPage() {
   
        return (
            <>
                <Gallery />
            </>
        );
    }

export default GalleryPage;